var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 8V12.3594L7.99999 11.3594V7.99998H11.3672L12.3672 6.99998H7.99999V0.99998H14V6.06248C14.0729 6.05206 14.1458 6.04295 14.2187 6.03513C14.2917 6.02732 14.3646 6.02342 14.4375 6.02342C14.6146 6.02342 14.8021 6.04425 15 6.08592V0H0V15H6.21877L6.46877 14H1.00003V8H7.00002ZM7.00002 1.00002V7.00001H1.00003V1.00002H7.00002ZM14.4375 7.02345C14.6458 7.02345 14.8451 7.05991 15.0352 7.13282C15.2253 7.20574 15.3919 7.3073 15.5352 7.43751C15.6784 7.56772 15.7917 7.72397 15.875 7.90626C15.9583 8.08855 16 8.28907 16 8.50782C16 8.72657 15.9636 8.9323 15.8906 9.12501C15.8177 9.31772 15.7031 9.4922 15.5469 9.64845L9.94534 15.25L7.00003 15.9844L7.73441 13.0391L13.336 7.4453C13.4818 7.29947 13.6511 7.19269 13.8438 7.12499C14.0365 7.05728 14.2344 7.02342 14.4375 7.02342V7.02345ZM15 8.54689C15 8.70314 14.9453 8.83595 14.8359 8.94532L9.42971 14.3438L8.37502 14.6094L8.64065 13.5547L14.0469 8.14845C14.099 8.09637 14.1602 8.05991 14.2305 8.03908C14.3008 8.01824 14.3698 8.00783 14.4375 8.00783C14.6042 8.00783 14.7396 8.056 14.8438 8.15236C14.9479 8.24871 15 8.38022 15 8.54689Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseLayout);
export default __webpack_public_path__ + "static/media/ChooseLayout.4e53b5eb6e8da6d0a85f2a934a79e52d.svg";
export { ForwardRef as ReactComponent };